import {GET_BILLING_LIST, GET_BILLING_REPORT_DATA} from '../actionTypes.js';
import{getAxiosInstance} from '../utils/axios-api';
import {getAccessToken} from '../utils/customMethods';
import { notify } from '../utils/notifications/notifications';
export const getBillingList = () =>  async dispatch => {
    try{
        const response = await getAxiosInstance().get(
            `/billing?access_token=${getAccessToken()}`
        );
        dispatch({ type: GET_BILLING_LIST, payload: response.data||[] });
    }catch(ex){
        dispatch({ type: GET_BILLING_LIST, payload: [] });
    }
};
export const saveBillingList=(body)=>async dispatch=>{
    try{
        const response = await getAxiosInstance().put(
            `/billing?access_token=${getAccessToken()}`, body      
        );
        if(response.status===200){
            notify('success',"Changes Saved successfully");  
            return true;            
        }
        else{
            notify('error',"Save changes failed.");
            return false
        }
        
    }catch(ex){
        notify('error',"Something went wrong. Please try again");
        return false;
    }    
}

export const getBillingReportData = (from,to) =>  async dispatch => {
    try{
        const response = await getAxiosInstance().get(
            `/tsBillingReport?fromDate=${from}&toDate=${to}&access_token=${getAccessToken()}`
        );
        dispatch({ type: GET_BILLING_REPORT_DATA, payload: response.data||{} });
    }catch(ex){
        dispatch({ type: GET_BILLING_REPORT_DATA, payload: {} });
    }
};